<template>
    <!-- 出行支付  -->
      <main-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" />
</template>

<script>
import MainPage from '@/views/components/MainPage.vue'
export default {
    name: 'travel',
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/0--46.png",
        }
    },
    computed: {
        title() {
            return this.$t('travel.title');
        },
        subtitle() {
            return this.$t('travel.subtitle');
        },
        description() {
            return this.$t('travel.description');
        },
        buttonText() {
            return this.$t('common.buttonText');
        }
    }
}
</script>